export const ROUTES = {
  HOME: '/',
  SIGNIN: '/signin',
  SOCIAL_AUTH: '/sa',
  SIGNUP: '/signup',
  SIGNUP_INFLUENCER: '/signup-influencer', //NOTE : not in use
  SIGNUP_BRAND: '/signup-brand', //NOTE : not in use
  FORGET_PASSWORD: '/forget-password',
  TEST_DASHBOARD: '/test-dashboard',
  MY_LINKS: '/my-links',
  BULK_UPLOAD: '/bulk-upload',
  ANALYTICS: '/analytics',
  USER_MANAGEMENT: '/user-management',
  CREATE_CAMPAIGN: '/create-campaign',
  EDIT_CAMPAIGN: '/edit-campaign/:id',
  PREVIEW_CAMPAIGN: '/preview-campaign',
  SCHEDULED_CAMPAIGN: '/scheduled-campaign',
  ACTIVE_CAMPAIGN: '/active-campaign',
  COMPLETED_CAMPAIGN: '/completed-campaign',
  ANALYTICS_CAMPAIGN: '/analytics-campaign',
  CAMPAIGN: '/campaign/:id',
  USER_DETAIL: '/user-detail',
  PROFILE: '/profile',
  WALLET: '/wallet',
  PLANS: '/plans',
  REDIRECT: '/redirect',
  TOKEN_REDIRECT: '/token-redirect',
  CHECKOUT: '/checkout/:label',
  YOUTUBE_AUTH_CALLBACK: '/yt/callback',
  INSTAGRAM_AUTH_CALLBACK: '/instagram/callback',
  TIKTOK_AUTH_CALLBACK: '/tiktok/callback',
  ACTIVATE_ACCOUNT: '/activate/:userId/:token/:emailId',
  ADMIN_USERS: '/admin/users',
  BRAND_SUBSCRIBERS: '/admin/brand-subscribers',
  BRAND: '/admin/brand',
  BRAND_DETAIL: '/admin/brand-detail/:brandId',
  CREATOR_SUBSCRIBERS: '/admin/creator-subscribers',
  NEWSLETTER_SUBSCRIBERS: '/admin/newsletter-subscribers',
  FLAGGED_SUBMISSIONS: '/admin/flagged-submissions',
  CASHBACK_LEDGER: '/admin/cashbacks',
  CASHBACK_DETAIL: '/admin/cashbacks/:id',
  BONUS_LEDGER: '/admin/bonus-ledger',
  CREATORS_WAITLIST: '/admin/creators-waitlist',
  CREATORS_DETAIL: '/admin/creators-waitlist/:id',
  WORLD_MAP: '/world-map',
  APP_DOWNLOAD: '/app-download',
  QR_CODE: '/qr-code',
  CAMPAIGN_SMARTLINK: '/campaign-smartlink/:id',
  CREATOR_SUBMISSIONS: '/creator-submissions',
  ADMIN_CAMPAIGNS: '/admin/campaigns',
  ADMIN_CAMPAIGN_DETAIL: '/admin/campaigns/:id',
  ADMIN_BRANDS: '/admin/brands',
  ADMIN_BRAND_DETAIL_NEW: '/admin/brands/:id',
  ADMIN_CREATORS: '/admin/creators',
  ADMIN_CREATOR_DETAIL: '/admin/creators/:id',
  CREATOR_PAYOUTS: '/admin/creator-payouts',
  ADMIN_SUBMISSIONS: '/admin/submissions',
  ADMIN_ANALYTICS: '/admin/analytics',
};
